import { Modal } from '@mui/material';
import {
  CircularProgress,
  ProgressType,
} from 'app/shared/components/generic-ui/CircularProgress';
import { useStyles } from './LoadingScreen.styles';

interface ILoadingScreenProps {
  text?: string;
}

export const LoadingScreen = ({ text }: ILoadingScreenProps) => {
  const { classes } = useStyles();

  return (
    <Modal open={true} className={classes.container}>
      {/* MUI Modal needs a child element that can hold a ref (not a Fragment). */}
      <div>
        <CircularProgress
          withLabel
          size={40}
          type={ProgressType.LIGHT}
          text={text}
        />
      </div>
    </Modal>
  );
};
